/** Customer-facing cake proof page — warm reveal experience (not staff driver UI). */
export const PINK = "#EE2677";
export const CREAM = "#FFF7FA";
export const TABLETOP_LOGO_SRC = `${process.env.PUBLIC_URL || ""}/tabletop-logo.png`;
export const CUTLERY_POUCH_IMAGE_SRC = `${process.env.PUBLIC_URL || ""}/cutlery-pouch-info.png?v=pink20260612`;
export const FATHERS_DAY_OFFER_URL = `${process.env.PUBLIC_URL || ""}/fathers_day_v4.html`;
export const FATHERS_DAY_PROMO_IMAGE_SRC = `${process.env.PUBLIC_URL || ""}/fathers-day-assets/fathersday-proof-card-10.png?v=10pct20260618b`;
/** Permanent ops line for customer proof “call for updates” — all orders. */
export const CUSTOMER_PROOF_CALL_HREF = "tel:+918178042333";

export const CUSTOMER_PROOF_PAGE_CSS = `
  .customer-proof-page {
    min-height: 100dvh;
    background: linear-gradient(165deg, #FFF7FA 0%, #F5F2EA 42%, #FFFBF5 100%);
    color: #2D2D2D;
    padding: 0;
    max-width: 480px;
    margin: 0 auto;
    overflow-x: hidden;
    box-sizing: border-box;
    font-family: system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
  }
  .customer-proof-page * { box-sizing: border-box; }

  .customer-proof-shell {
    padding: 0 0 calc(24px + env(safe-area-inset-bottom));
  }
  .customer-proof-shell--sticky {
    padding-bottom: calc(132px + env(safe-area-inset-bottom));
  }
  .customer-proof-shell--call-footer {
    padding-bottom: calc(128px + env(safe-area-inset-bottom));
  }

  .customer-proof-top {
    padding: 14px 16px 10px;
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .customer-proof-top-copy { flex: 1; min-width: 0; }
  .call-before-delivery-banner {
    margin: 0 12px 10px;
    padding: 12px 14px;
    border-radius: 12px;
    background: #DC2626;
    color: #fff;
    font-size: 14px;
    font-weight: 800;
    text-align: center;
    letter-spacing: 0.02em;
    line-height: 1.35;
    box-shadow: 0 4px 14px rgba(220, 38, 38, 0.45);
    animation: call-before-pulse 1.8s ease-in-out infinite;
  }
  @keyframes call-before-pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.01); }
  }
  .cp-order-chip {
    flex-shrink: 0;
    padding: 6px 10px;
    border-radius: 999px;
    background: white;
    border: 1px solid rgba(238, 38, 119, 0.2);
    font-size: 11px;
    font-weight: 800;
    color: #BE185D;
    letter-spacing: 0.02em;
  }
  .customer-proof-logo {
    width: 48px; height: 48px; border-radius: 50%;
    border: 2px solid #EBB3A9; background: white; overflow: hidden; flex-shrink: 0;
    box-shadow: 0 2px 12px rgba(238, 38, 119, 0.12);
  }
  .customer-proof-logo img { width: 100%; height: 100%; object-fit: cover; display: block; }
  .customer-proof-brand-name { font-size: 15px; font-weight: 800; color: #2D2D2D; line-height: 1.2; }
  .customer-proof-brand-tag { font-size: 11px; color: rgba(45,45,45,0.5); margin-top: 2px; }

  .customer-proof-hero-wrap {
    margin: 6px 16px 0;
    padding: 22px 18px 18px;
    border-radius: 28px;
    background: linear-gradient(155deg, #FFFFFF 0%, #FFF5F9 48%, #FFE8F0 100%);
    border: 1px solid rgba(238, 38, 119, 0.14);
    box-shadow: 0 12px 40px rgba(238, 38, 119, 0.1);
    position: relative;
    overflow: hidden;
  }
  .cp-hero-eyebrow {
    margin: 0 0 6px;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba(190, 24, 93, 0.75);
  }
  .cp-hero-sub {
    margin: -6px 0 16px;
    font-size: 14px;
    font-weight: 700;
    color: rgba(45, 45, 45, 0.62);
  }
  .customer-proof-hero-wrap::before {
    content: "";
    position: absolute;
    top: -40px; right: -40px;
    width: 120px; height: 120px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(238,38,119,0.08) 0%, transparent 70%);
    pointer-events: none;
  }
  .customer-proof-greeting {
    font-size: 26px; font-weight: 900; line-height: 1.15;
    color: ${PINK}; margin: 0 0 14px;
    letter-spacing: -0.02em;
  }
  .customer-proof-hero-btn {
    display: block; width: 100%; padding: 0; border: none; background: none;
    border-radius: 20px; overflow: hidden; cursor: pointer; text-align: left;
    box-shadow: 0 6px 24px rgba(0,0,0,0.12);
    border: 2px solid rgba(255,255,255,0.9);
  }
  .customer-proof-hero-btn img {
    width: 100%; max-height: 380px; object-fit: cover; display: block;
  }
  .customer-proof-hero-caption {
    padding: 13px 16px;
    background: linear-gradient(135deg, ${PINK} 0%, #DB2777 100%);
    color: white; font-size: 14px; font-weight: 900;
    display: flex; align-items: center; justify-content: space-between; gap: 8px;
    letter-spacing: 0.01em;
  }
  .customer-proof-hero-tap { font-size: 11px; font-weight: 800; opacity: 0.92; color: white; }

  .cp-fathers-day-promo {
    position: relative;
    isolation: isolate;
    display: grid;
    grid-template-columns: 1fr;
    gap: 0;
    margin: 16px 16px 0;
    padding: 0;
    border-radius: 28px;
    text-decoration: none;
    color: #3A2414;
    background:
      radial-gradient(circle at 14% 8%, rgba(255, 255, 255, 0.88) 0%, rgba(255, 255, 255, 0) 34%),
      linear-gradient(135deg, #FFF3C4 0%, #FFE4ED 48%, #FFF7FA 100%);
    border: 1px solid rgba(238, 38, 119, 0.24);
    box-shadow: 0 14px 42px rgba(238, 38, 119, 0.18), 0 2px 10px rgba(120, 53, 15, 0.08);
    overflow: hidden;
    -webkit-tap-highlight-color: transparent;
  }
  .cp-fathers-day-promo:active { transform: scale(0.99); }
  .cp-fathers-day-promo--compact {
    display: block;
    margin: 2px 0 14px;
    border-radius: 18px;
    background: linear-gradient(135deg, #FFF7FA 0%, #FFEAF2 100%);
    box-shadow: 0 8px 24px rgba(238, 38, 119, 0.14);
  }
  .cp-fathers-day-promo--compact .cp-fathers-day-media,
  .cp-fathers-day-promo--compact .cp-fathers-day-glow {
    display: none;
  }
  .cp-fathers-day-promo--compact .cp-fathers-day-content {
    padding: 12px 12px;
    border-radius: 18px;
    background: rgba(255, 255, 255, 0.72);
  }
  .cp-fathers-day-promo--compact .cp-fathers-day-icon {
    width: 40px;
    height: 40px;
    border-radius: 14px;
  }
  .cp-fathers-day-promo--compact .cp-fathers-day-kicker {
    font-size: 9px;
    padding: 2px 7px;
  }
  .cp-fathers-day-promo--compact .cp-fathers-day-title {
    font-size: 15px;
  }
  .cp-fathers-day-promo--compact .cp-fathers-day-sub {
    font-size: 11px;
  }
  .cp-fathers-day-promo--compact .cp-fathers-day-action {
    width: 32px;
    height: 32px;
  }
  @keyframes cp-fathers-day-throb {
    0%, 100% {
      transform: scale(1);
      box-shadow: 0 14px 42px rgba(238, 38, 119, 0.18), 0 2px 10px rgba(120, 53, 15, 0.08);
    }
    50% {
      transform: scale(1.025);
      box-shadow: 0 18px 52px rgba(238, 38, 119, 0.3), 0 4px 14px rgba(120, 53, 15, 0.12);
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .cp-fathers-day-content { animation: none; }
  }
  .cp-fathers-day-glow {
    position: absolute;
    inset: auto -38px -42px auto;
    width: 122px;
    height: 122px;
    border-radius: 999px;
    background: radial-gradient(circle, rgba(238, 38, 119, 0.18) 0%, rgba(238, 38, 119, 0) 68%);
    z-index: -1;
  }
  .cp-fathers-day-media {
    position: relative;
    aspect-ratio: 1 / 0.72;
    background: #FFEAF2;
    overflow: hidden;
  }
  .cp-fathers-day-media img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
  .cp-fathers-day-badge {
    position: absolute;
    left: 14px;
    top: 14px;
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 7px 11px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.92);
    color: #BE185D;
    font-size: 11px;
    font-weight: 950;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
  }
  .cp-fathers-day-content {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 15px 14px 16px;
    transform-origin: center;
    animation: cp-fathers-day-throb 2.4s ease-in-out infinite;
  }
  .cp-fathers-day-icon {
    flex-shrink: 0;
    width: 44px;
    height: 44px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, ${PINK} 0%, #DB2777 100%);
    color: #FFFFFF;
    box-shadow: 0 8px 18px rgba(238, 38, 119, 0.3);
  }
  .cp-fathers-day-copy {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .cp-fathers-day-kicker {
    width: max-content;
    max-width: 100%;
    padding: 3px 8px;
    border-radius: 999px;
    background: rgba(255, 255, 255, 0.72);
    color: #BE185D;
    font-size: 10px;
    font-weight: 900;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }
  .cp-fathers-day-title {
    margin-top: 2px;
    font-size: 18px;
    font-weight: 950;
    line-height: 1.12;
    letter-spacing: -0.02em;
    color: #2D2D2D;
  }
  .cp-fathers-day-sub {
    font-size: 12px;
    font-weight: 700;
    line-height: 1.28;
    color: rgba(61, 36, 20, 0.68);
  }
  .cp-fathers-day-action {
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    border-radius: 999px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.82);
    color: ${PINK};
    border: 1px solid rgba(238, 38, 119, 0.18);
  }

  .customer-proof-details {
    margin: 0;
    padding: 12px 14px 0;
    display: flex;
    flex-direction: column;
    gap: 0;
  }
  .customer-proof-details .driver-card {
    margin-bottom: 12px;
  }
  .customer-proof-details .driver-card:last-child {
    margin-bottom: 0;
  }
  .customer-proof-chip {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 8px 14px; border-radius: 999px;
    background: white; border: 1px solid #F2D4CE;
    font-size: 13px; font-weight: 700; color: #2D2D2D;
    box-shadow: 0 1px 4px rgba(0,0,0,0.04);
  }
  .customer-proof-chip--pink {
    background: #FFEAF2; border-color: rgba(238,38,119,0.25); color: #BE185D;
  }

  .customer-proof-message {
    margin: 14px 16px 0;
    padding: 16px 18px;
    border-radius: 18px;
    background: #FFFBEB;
    border: 1px solid #FDE68A;
    position: relative;
  }
  .customer-proof-message-label {
    font-size: 10px; font-weight: 800; text-transform: uppercase;
    letter-spacing: 0.08em; color: #B45309; margin-bottom: 6px;
  }
  .customer-proof-message-text {
    font-size: 18px; font-weight: 700; line-height: 1.35;
    color: #78350F; font-style: italic;
  }

  .customer-proof-section {
    margin: 16px 16px 0;
    border-radius: 18px;
    background: white;
    border: 1px solid #EBB3A9;
    overflow: hidden;
    box-shadow: 0 2px 10px rgba(0,0,0,0.04);
  }
  .customer-proof-section-toggle {
    width: 100%; display: flex; align-items: center; justify-content: space-between;
    gap: 10px; padding: 14px 16px; border: none; background: white;
    font-size: 14px; font-weight: 800; color: #0F766E; cursor: pointer; text-align: left;
  }
  .customer-proof-section-toggle span { flex: 1; }
  .customer-proof-section-chevron {
    font-size: 18px; color: #9CA3AF; transition: transform 0.2s ease;
  }
  .customer-proof-section-chevron--open { transform: rotate(180deg); }
  .customer-proof-section-body {
    padding: 0 14px 14px;
    border-top: 1px solid #F5F2EA;
  }
  .customer-proof-section--pay {
    border-color: rgba(238, 38, 119, 0.22);
    box-shadow: 0 4px 16px rgba(238, 38, 119, 0.08);
  }
  .customer-proof-section--pay .customer-proof-section-toggle {
    color: ${PINK};
    background: linear-gradient(180deg, #FFFFFF 0%, #FFF8FB 100%);
  }
  .customer-proof-section--pay .customer-proof-section-body {
    border-top-color: rgba(238, 38, 119, 0.12);
    background: linear-gradient(180deg, #FFFBFD 0%, #FFFFFF 100%);
  }
  .customer-proof-section--pay-open {
    overflow: visible;
  }
  .customer-proof-section--pay-open > .customer-pay-due--open {
    margin: 0;
    padding: 14px 14px 16px;
    border: none;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
  }
  .customer-proof-section--pay-open > .customer-pay-due--open .customer-pay-scanner-btn {
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
  }
  .customer-proof-section--pay-open > .customer-pay-due--open .customer-pay-alt-apps {
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
  }
  .customer-proof-section-hint {
    font-size: 12px; color: #6B7280; line-height: 1.4;
    margin: 10px 0 12px;
  }
  .customer-proof-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
  .customer-proof-shot {
    overflow: hidden; border-radius: 14px;
    border: 1px solid rgba(15,118,110,0.2); background: #FAFAFA;
    padding: 0; cursor: pointer; width: 100%; text-align: left;
  }
  .customer-proof-shot img {
    width: 100%; aspect-ratio: 1; object-fit: cover; display: block;
  }
  .customer-proof-shot-label {
    padding: 10px 8px; font-size: 12px; font-weight: 900; color: white;
    text-align: center;
    background: linear-gradient(135deg, ${PINK} 0%, #DB2777 100%);
    border-top: none;
  }
  .customer-proof-stack { display: flex; flex-direction: column; gap: 10px; }
  .customer-proof-weight-badge {
    display: inline-flex; align-items: center; gap: 6px;
    padding: 6px 12px; border-radius: 999px;
    background: #FFEAF2; color: #C2185B; font-size: 13px; font-weight: 800;
    margin-bottom: 10px;
  }

  .customer-proof-cutlery-wrap {
    margin: 14px 14px 0;
    padding: 14px 12px;
    border-radius: 18px;
    background: linear-gradient(145deg, #FFF7FA 0%, #FFE8F0 55%, #FFF0F6 100%);
    border: 1px solid rgba(238, 38, 119, 0.2);
    box-shadow: 0 4px 16px rgba(238, 38, 119, 0.08);
  }
  .customer-proof-cutlery-img {
    display: block;
    width: 100%;
    height: auto;
    border-radius: 12px;
  }

  .customer-proof-care {
    margin: 16px 16px 0;
  }
  .customer-proof-care--friendly {
    padding: 16px 16px 14px;
    border-radius: 20px;
    background: linear-gradient(155deg, #FFFBF5 0%, #FFF7ED 55%, #FEF3C7 100%);
    border: 1px solid rgba(251, 191, 36, 0.28);
    box-shadow: 0 6px 20px rgba(251, 191, 36, 0.1);
  }
  .customer-proof-care-inner {
    padding: 12px 14px;
  }
  .customer-proof-care-head {
    display: flex;
    gap: 10px;
    align-items: flex-start;
  }
  .customer-proof-care-icon {
    flex-shrink: 0;
    margin-top: 2px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #F472B6 0%, ${PINK} 100%);
    color: white;
    box-shadow: 0 4px 12px rgba(238, 38, 119, 0.2);
  }
  .customer-proof-care-title {
    font-size: 15px;
    font-weight: 900;
    color: #2D2D2D;
    line-height: 1.25;
  }
  .customer-proof-care-lead {
    margin-top: 4px;
    font-size: 13px;
    line-height: 1.45;
    color: rgba(45, 45, 45, 0.72);
  }
  .customer-proof-care-list {
    margin: 12px 0 0;
    padding: 0 0 0 18px;
    font-size: 13px;
    line-height: 1.5;
    color: rgba(45, 45, 45, 0.68);
  }
  .customer-proof-care-list li { margin-bottom: 4px; }
  .customer-proof-care-note {
    margin: 10px 0 0;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.45;
    color: rgba(190, 24, 93, 0.85);
  }

  .customer-proof-empty {
    margin: 24px 16px; padding: 20px; text-align: center;
    border-radius: 18px; background: white; border: 1px dashed #EBB3A9;
    color: #6B7280; font-size: 14px; line-height: 1.5;
  }

  .customer-nutrition-wrap {
    margin: 0;
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .nf-label {
    box-sizing: border-box;
    width: 100%;
    max-width: 280px;
    padding: 6px 8px 8px;
    border: 1px solid #000;
    background: #fff;
    color: #000;
    font-family: Helvetica, Arial, "Liberation Sans", sans-serif;
    font-size: 12px;
    line-height: 1.2;
    -webkit-font-smoothing: antialiased;
  }
  .nf-title {
    font-size: 28px;
    font-weight: 800;
    line-height: 1;
    letter-spacing: -0.02em;
  }
  .nf-serving {
    margin-top: 4px;
    font-size: 12px;
    font-weight: 700;
  }
  .nf-bar-thick {
    height: 8px;
    margin: 4px 0 2px;
    background: #000;
  }
  .nf-bar-medium {
    height: 4px;
    margin: 2px 0;
    background: #000;
  }
  .nf-amount {
    font-size: 11px;
    font-weight: 700;
  }
  .nf-calories-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    margin: 2px 0;
    font-weight: 800;
  }
  .nf-calories-label {
    font-size: 22px;
    line-height: 1;
  }
  .nf-calories-value {
    font-size: 30px;
    line-height: 1;
    letter-spacing: -0.02em;
  }
  .nf-dv-head {
    display: flex;
    justify-content: flex-end;
    padding: 2px 0;
    font-size: 11px;
    font-weight: 800;
    border-bottom: 1px solid #000;
  }
  .nf-row {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    padding: 2px 0;
    border-bottom: 1px solid #000;
    font-size: 12px;
  }
  .nf-row-bold {
    font-weight: 800;
  }
  .nf-row-indent {
    padding-left: 14px;
    font-weight: 400;
  }
  .nf-row-indent2 {
    padding-left: 28px;
    font-weight: 400;
  }
  .nf-row em {
    font-style: italic;
    font-weight: 400;
  }
  .nf-row-pct {
    font-weight: 800;
    white-space: nowrap;
  }
  .nf-micro {
    font-size: 12px;
    font-weight: 400;
  }
  .nf-footnote {
    margin: 4px 0 0;
    font-size: 9px;
    line-height: 1.25;
    font-weight: 400;
  }

  .customer-proof-order-ref {
    margin: 12px 16px 0; text-align: center;
    font-size: 11px; color: rgba(45,45,45,0.4); font-weight: 600;
  }

  .customer-proof-call-footer {
    position: fixed; left: 0; right: 0; bottom: 0; z-index: 50;
    max-width: 480px; margin: 0 auto;
    padding: 12px 16px calc(14px + env(safe-area-inset-bottom));
    background: #FFFFFF;
    border-top: 1px solid rgba(238, 38, 119, 0.15);
    box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.06);
  }
  .customer-proof-call-prompt {
    text-align: center; font-size: 12px; font-weight: 700;
    color: #9D174D; margin: 0 0 8px; letter-spacing: 0.02em;
  }
  .customer-proof-call-btn {
    display: flex; align-items: center; justify-content: center; gap: 10px;
    width: 100%; padding: 16px 20px; border-radius: 999px; border: none;
    background: linear-gradient(135deg, ${PINK} 0%, #DB2777 100%);
    color: white; font-size: 17px; font-weight: 900; text-decoration: none;
    box-shadow: 0 6px 20px rgba(238, 38, 119, 0.45);
    cursor: pointer; -webkit-tap-highlight-color: transparent;
    animation: customer-proof-pulse 2.5s ease-in-out infinite;
  }
  .customer-proof-call-btn:active { transform: scale(0.98); }
  @keyframes customer-proof-pulse {
    0%, 100% { box-shadow: 0 6px 20px rgba(238, 38, 119, 0.45); }
    50% { box-shadow: 0 6px 28px rgba(238, 38, 119, 0.65); }
  }

  .customer-proof-checklist-wrap,
  .customer-proof-approval-wrap,
  .customer-proof-approved-banner,
  .customer-proof-review-wrap,
  .customer-proof-review-thanks {
    display: none;
  }

  /* \u2500\u2500 Confirm panel (checklist + timer + done) \u2500\u2500 */
  .cp-confirm-card {
    margin: 18px 16px 0;
    padding: 22px 18px 20px;
    border-radius: 28px;
    background: #FFFFFF;
    border: 1px solid rgba(238, 38, 119, 0.14);
    box-shadow: 0 14px 44px rgba(238, 38, 119, 0.1);
  }
  .cp-confirm-card--wait {
    text-align: center;
    background: linear-gradient(145deg, #FFF7FA 0%, #FFFFFF 100%);
  }
  .cp-confirm-head { margin-bottom: 18px; }
  .cp-confirm-eyebrow {
    display: inline-block;
    margin-bottom: 8px;
    padding: 5px 10px;
    border-radius: 999px;
    background: #FFEAF2;
    color: #BE185D;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }
  .cp-confirm-title {
    margin: 0 0 6px;
    font-size: 22px;
    font-weight: 900;
    line-height: 1.15;
    letter-spacing: -0.03em;
    color: #2D2D2D;
  }
  .cp-confirm-sub,
  .cp-confirm-wait {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: rgba(45, 45, 45, 0.62);
    font-weight: 600;
  }

  .cp-timer-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 0 20px;
    padding: 16px 12px 14px;
    border-radius: 22px;
    background: linear-gradient(160deg, #FFF7FA 0%, #FFEAF2 100%);
    border: 1px solid rgba(238, 38, 119, 0.12);
  }
  .cp-timer-block--urgent {
    background: linear-gradient(160deg, #FFF1F2 0%, #FFE4E6 100%);
    border-color: rgba(225, 29, 72, 0.22);
  }
  .cp-timer-ring-wrap {
    position: relative;
    width: 132px;
    height: 132px;
    margin-bottom: 8px;
  }
  .cp-timer-ring {
    width: 100%;
    height: 100%;
    transform: rotate(-90deg);
  }
  .cp-timer-ring-track {
    fill: none;
    stroke: rgba(238, 38, 119, 0.12);
    stroke-width: 7;
  }
  .cp-timer-ring-progress {
    fill: none;
    stroke: ${PINK};
    stroke-width: 7;
    stroke-linecap: round;
    stroke-dasharray: 326.73;
    transition: stroke-dashoffset 1s linear;
  }
  .cp-timer-block--urgent .cp-timer-ring-progress { stroke: #E11D48; }
  .cp-timer-center {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;
  }
  .cp-timer-clock-icon { color: #BE185D; opacity: 0.85; }
  .cp-timer-digits {
    font-size: 36px;
    font-weight: 900;
    line-height: 1;
    letter-spacing: -0.04em;
    color: #9D174D;
    font-variant-numeric: tabular-nums;
  }
  .cp-timer-block--urgent .cp-timer-digits { color: #BE123C; }
  .cp-timer-caption {
    margin: 0;
    font-size: 12px;
    font-weight: 700;
    color: #9D174D;
    text-align: center;
  }

  .cp-checklist-rows {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 18px;
  }
  .cp-check-row {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 16px;
    background: #FAFAFA;
    border: 1px solid rgba(238, 38, 119, 0.08);
  }
  .cp-check-icon {
    flex-shrink: 0;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #16A34A 0%, #15803D 100%);
    color: white;
    margin-top: 1px;
    box-shadow: 0 3px 10px rgba(22, 163, 74, 0.28);
  }
  .cp-check-copy {
    display: flex;
    flex-direction: column;
    gap: 3px;
    min-width: 0;
  }
  .cp-check-label {
    font-size: 13px;
    font-weight: 900;
    color: #2D2D2D;
    letter-spacing: -0.01em;
  }
  .cp-check-detail {
    font-size: 13px;
    line-height: 1.4;
    color: rgba(45, 45, 45, 0.62);
    word-break: break-word;
  }

  .cp-timeline-card {
    margin: 12px 16px 0;
    padding: 18px 16px 16px;
    border-radius: 24px;
    background: white;
    border: 1px solid rgba(238, 38, 119, 0.12);
    box-shadow: 0 10px 32px rgba(238, 38, 119, 0.08);
  }
  .cp-timeline-head { margin-bottom: 12px; }
  .cp-timeline-title {
    margin: 0;
    font-size: 17px;
    font-weight: 900;
    color: #2D2D2D;
    letter-spacing: -0.02em;
  }
  .cp-timeline-sub {
    margin: 4px 0 0;
    font-size: 12px;
    font-weight: 700;
    color: rgba(45, 45, 45, 0.55);
  }
  .cp-timeline-progress {
    height: 6px;
    border-radius: 999px;
    background: rgba(238, 38, 119, 0.12);
    overflow: hidden;
    margin-bottom: 16px;
  }
  .cp-timeline-progress-fill {
    height: 100%;
    border-radius: 999px;
    background: linear-gradient(90deg, ${PINK} 0%, #DB2777 100%);
    transition: width 0.35s ease;
  }
  .cp-timeline-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  .cp-timeline-item {
    display: flex;
    gap: 12px;
    align-items: stretch;
  }
  .cp-timeline-item--dim { opacity: 0.58; }
  .cp-timeline-rail {
    position: relative;
    width: 28px;
    flex-shrink: 0;
    display: flex;
    justify-content: center;
  }
  .cp-timeline-line {
    position: absolute;
    top: 28px;
    bottom: 0;
    left: 50%;
    width: 2px;
    transform: translateX(-50%);
    background: rgba(235, 179, 169, 0.55);
  }
  .cp-timeline-line--done { background: rgba(22, 163, 74, 0.35); }
  .cp-timeline-icon {
    position: relative;
    z-index: 1;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .cp-timeline-icon--done {
    background: linear-gradient(135deg, #16A34A 0%, #15803D 100%);
    color: white;
    box-shadow: 0 4px 12px rgba(22, 163, 74, 0.28);
  }
  .cp-timeline-icon--current {
    background: white;
    border: 2px solid ${PINK};
    color: ${PINK};
  }
  .cp-timeline-dot { fill: currentColor; }
  .cp-timeline-icon--pending {
    background: #FFF7FA;
    border: 2px solid rgba(235, 179, 169, 0.75);
  }
  .cp-timeline-icon--cancelled {
    background: rgba(232, 126, 161, 0.18);
    color: #BE123C;
  }
  .cp-timeline-body { min-width: 0; flex: 1; }
  .cp-timeline-body--spaced { padding-bottom: 18px; }
  .cp-timeline-toggle {
    display: flex;
    width: 100%;
    align-items: flex-start;
    justify-content: space-between;
    gap: 8px;
    padding: 0;
    border: none;
    background: none;
    text-align: left;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  .cp-timeline-copy { min-width: 0; flex: 1; }
  .cp-timeline-label {
    margin: 0;
    font-size: 15px;
    font-weight: 900;
    color: #2D2D2D;
    letter-spacing: -0.01em;
  }
  .cp-timeline-label--current { color: ${PINK}; }
  .cp-timeline-detail {
    margin: 4px 0 0;
    font-size: 13px;
    line-height: 1.4;
    color: rgba(45, 45, 45, 0.62);
  }
  .cp-timeline-at {
    margin: 4px 0 0;
    font-size: 11px;
    font-weight: 700;
    color: rgba(45, 45, 45, 0.45);
  }
  .cp-timeline-photos-hint {
    margin: 6px 0 0;
    font-size: 11px;
    font-weight: 800;
    color: ${PINK};
  }
  .cp-timeline-chevron {
    flex-shrink: 0;
    margin-top: 2px;
    color: ${PINK};
    transition: transform 0.2s ease;
  }
  .cp-timeline-chevron--open { transform: rotate(180deg); }
  .cp-timeline-photos {
    display: grid;
    gap: 8px;
    margin-top: 10px;
  }
  .cp-timeline-photos--grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .cp-timeline-photo-btn {
    padding: 0;
    border: 1px solid rgba(238, 38, 119, 0.12);
    border-radius: 14px;
    overflow: hidden;
    background: #FFF7FA;
    text-align: left;
    cursor: pointer;
  }
  .cp-timeline-photo-btn img {
    display: block;
    width: 100%;
    aspect-ratio: 4 / 3;
    object-fit: cover;
  }
  .cp-timeline-photo-btn span {
    display: block;
    padding: 8px 10px;
    font-size: 10px;
    font-weight: 800;
    color: #9D174D;
  }

  .cp-done-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 17px 20px;
    border-radius: 999px;
    border: none;
    background: linear-gradient(135deg, ${PINK} 0%, #DB2777 100%);
    color: white;
    font-size: 17px;
    font-weight: 900;
    letter-spacing: -0.01em;
    box-shadow: 0 8px 24px rgba(238, 38, 119, 0.38);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  .cp-done-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    box-shadow: none;
  }
  .cp-done-btn:active:not(:disabled) { transform: scale(0.98); }
  .cp-done-btn--secondary {
    margin-top: 4px;
    background: linear-gradient(135deg, #2D2D2D 0%, #444 100%);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  }

  .cp-confirm-float-hint {
    margin: 16px 0 0;
    padding: 12px 14px;
    border-radius: 14px;
    background: #FFEAF2;
    border: 1px dashed rgba(238, 38, 119, 0.28);
    font-size: 12px;
    font-weight: 700;
    line-height: 1.45;
    color: #9D174D;
    text-align: center;
  }

  .cp-sticky-bar {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 60;
    max-width: 480px;
    margin: 0 auto;
    padding: 10px 16px calc(12px + env(safe-area-inset-bottom));
    background: #FFFFFF;
    border-top: 1px solid rgba(238, 38, 119, 0.16);
    box-shadow: 0 -8px 28px rgba(0, 0, 0, 0.1);
  }
  .cp-sticky-bar-inner {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .cp-sticky-timer-row {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: #9D174D;
  }
  .cp-sticky-timer-label {
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }
  .cp-sticky-timer-digits {
    font-size: 20px;
    font-weight: 900;
    font-variant-numeric: tabular-nums;
    color: ${PINK};
  }
  .cp-sticky-done {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 16px 18px;
    border: none;
    border-radius: 999px;
    background: linear-gradient(135deg, ${PINK} 0%, #DB2777 100%);
    color: white;
    font-size: 17px;
    font-weight: 900;
    letter-spacing: -0.01em;
    cursor: pointer;
    box-shadow: 0 8px 24px rgba(238, 38, 119, 0.42);
    animation: cp-sticky-done-pulse 2.2s ease-in-out infinite;
    -webkit-tap-highlight-color: transparent;
  }
  .cp-sticky-done:disabled {
    opacity: 0.55;
    animation: none;
    box-shadow: none;
  }
  .cp-sticky-done:active:not(:disabled) { transform: scale(0.98); }
  @keyframes cp-sticky-done-pulse {
    0%, 100% { box-shadow: 0 8px 24px rgba(238, 38, 119, 0.42); transform: scale(1); }
    50% { box-shadow: 0 10px 32px rgba(238, 38, 119, 0.58); transform: scale(1.01); }
  }

  .cp-success-banner {
    margin: 18px 16px 0;
    padding: 18px 16px;
    border-radius: 22px;
    background: linear-gradient(135deg, #F0FDF4 0%, #ECFDF5 100%);
    border: 1px solid #86EFAC;
    display: flex;
    align-items: flex-start;
    gap: 12px;
    color: #166534;
  }
  .cp-success-title {
    margin: 0 0 2px;
    font-size: 16px;
    font-weight: 900;
  }
  .cp-success-text {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.4;
    opacity: 0.88;
  }

  .cp-more-section {
    margin-top: 22px;
    padding-top: 6px;
    padding-bottom: 8px;
  }
  .cp-more-label {
    margin: 0 16px 12px;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(45, 45, 45, 0.42);
  }
  .cp-info-card {
    margin: 0 16px 12px;
    padding: 14px 16px;
    border-radius: 18px;
    background: white;
    border: 1px solid rgba(238, 38, 119, 0.1);
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  }
  .customer-proof-details .cp-info-card {
    margin: 0 0 12px;
  }
  .cp-info-card-label {
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: rgba(45, 45, 45, 0.45);
    margin-bottom: 8px;
  }
  .cp-info-pill {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border-radius: 999px;
    background: #FFEAF2;
    color: #BE185D;
    font-size: 14px;
    font-weight: 800;
  }
  .cp-info-meta {
    margin: 10px 0 0;
    font-size: 13px;
    font-weight: 600;
    color: rgba(45, 45, 45, 0.55);
  }
  .cp-order-summary-card {
    background: linear-gradient(155deg, #FFFFFF 0%, #FFF8FB 40%, #F0F9FF 100%);
    border: 1px solid rgba(238, 38, 119, 0.12);
  }
  .cp-order-chip-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
  }
  .cp-order-chip-grid .cp-order-chip {
    display: inline-flex;
    align-items: center;
    padding: 8px 12px;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: -0.01em;
    border: 1.5px solid transparent;
    flex-shrink: unset;
  }
  .cp-order-chip-grid .cp-order-chip--flavor {
    background: #FFE4EC;
    color: #BE185D;
    border-color: rgba(238, 38, 119, 0.25);
  }
  .cp-order-chip-grid .cp-order-chip--base {
    background: #FEF3C7;
    color: #92400E;
    border-color: rgba(245, 158, 11, 0.35);
  }
  .cp-order-chip-grid .cp-order-chip--sweet {
    background: #E0F2FE;
    color: #0369A1;
    border-color: rgba(14, 165, 233, 0.35);
  }
  .cp-order-chip-grid .cp-order-chip--weight {
    background: #ECFDF5;
    color: #047857;
    border-color: rgba(16, 185, 129, 0.35);
  }

  /* \u2500\u2500 Review card \u2500\u2500 */
  .cp-review-card {
    margin: 24px 16px 0;
    padding: 22px 18px 20px;
    border-radius: 28px;
    background: #FFFFFF;
    border: 1px solid rgba(238, 38, 119, 0.14);
    box-shadow: 0 10px 36px rgba(238, 38, 119, 0.08);
    text-align: center;
  }
  .cp-review-card--done {
    background: linear-gradient(145deg, #FFFBEB 0%, #FFFFFF 100%);
    border-color: #FCD34D;
  }
  .cp-review-title {
    margin: 0 0 6px;
    font-size: 22px;
    font-weight: 900;
    letter-spacing: -0.03em;
    color: #2D2D2D;
  }
  .cp-review-sub {
    margin: 0 0 18px;
    font-size: 13px;
    line-height: 1.5;
    color: rgba(45, 45, 45, 0.58);
    font-weight: 600;
  }
  .cp-stars {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-bottom: 16px;
  }
  .cp-star-btn {
    padding: 4px;
    border: none;
    background: none;
    cursor: pointer;
    line-height: 0;
  }
  .cp-star-filled {
    width: 38px;
    height: 38px;
    color: #F59E0B;
    fill: #F59E0B;
    filter: drop-shadow(0 2px 6px rgba(245, 158, 11, 0.35));
  }
  .cp-star-empty {
    width: 38px;
    height: 38px;
    color: #E5E7EB;
    fill: #E5E7EB;
  }
  .cp-review-stars-display {
    display: flex;
    justify-content: center;
    gap: 6px;
    margin-bottom: 12px;
  }
  .cp-review-text {
    width: 100%;
    min-height: 96px;
    padding: 14px 16px;
    border-radius: 18px;
    border: 1px solid rgba(238, 38, 119, 0.16);
    background: #FAFAFA;
    font-size: 14px;
    line-height: 1.45;
    color: #2D2D2D;
    resize: vertical;
    font-family: inherit;
    text-align: left;
    margin-bottom: 14px;
  }
  .cp-review-text:focus {
    outline: none;
    border-color: ${PINK};
    background: white;
    box-shadow: 0 0 0 3px rgba(238, 38, 119, 0.1);
  }
  .cp-review-thanks-title {
    margin: 0 0 4px;
    font-size: 18px;
    font-weight: 900;
    color: #92400E;
  }
  .cp-review-thanks-text {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: rgba(146, 64, 14, 0.75);
  }

  .customer-proof-checklist-wrap {
    margin: 16px 16px 0;
    padding: 18px 16px;
    border-radius: 22px;
    background: #FFFFFF;
    border: 1px solid rgba(238, 38, 119, 0.16);
    box-shadow: 0 6px 24px rgba(238, 38, 119, 0.08);
  }
  .customer-proof-checklist-title {
    margin: 0 0 4px;
    font-size: 18px;
    font-weight: 900;
    color: #2D2D2D;
    letter-spacing: -0.02em;
  }
  .customer-proof-checklist-hint {
    margin: 0 0 14px;
    font-size: 12px;
    line-height: 1.45;
    color: #9D174D;
    font-weight: 600;
  }
  .customer-proof-checklist {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .customer-proof-check-item {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 12px 14px;
    border-radius: 16px;
    background: linear-gradient(135deg, #F0FDF4 0%, #ECFDF5 100%);
    border: 1px solid #86EFAC;
  }
  .customer-proof-check-mark {
    flex-shrink: 0;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #16A34A;
    color: white;
    font-size: 14px;
    font-weight: 900;
    margin-top: 1px;
  }
  .customer-proof-check-body { min-width: 0; flex: 1; }
  .customer-proof-check-label {
    font-size: 14px;
    font-weight: 900;
    color: #166534;
    margin: 0 0 2px;
  }
  .customer-proof-check-detail {
    font-size: 13px;
    line-height: 1.4;
    color: #3F6212;
    margin: 0;
    word-break: break-word;
  }

  .customer-proof-approval-wrap {
    margin: 16px 16px 0;
    padding: 18px 16px;
    border-radius: 22px;
    background: linear-gradient(145deg, #FFF0F6 0%, #FFFFFF 100%);
    border: 2px solid rgba(238, 38, 119, 0.22);
    box-shadow: 0 8px 28px rgba(238, 38, 119, 0.12);
  }
  .customer-proof-approval-wait {
    margin: 0;
    font-size: 14px;
    line-height: 1.5;
    color: #9D174D;
    font-weight: 700;
    text-align: center;
  }
  .customer-proof-timer {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 14px;
    border-radius: 14px;
    background: rgba(255,255,255,0.9);
    font-size: 22px;
    font-weight: 900;
    color: #9D174D;
    margin-bottom: 12px;
  }
  .customer-proof-timer-unit {
    font-size: 13px;
    font-weight: 800;
    opacity: 0.85;
  }
  .customer-proof-done-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 16px 20px;
    border-radius: 999px;
    border: none;
    background: linear-gradient(135deg, ${PINK} 0%, #DB2777 100%);
    color: white;
    font-size: 17px;
    font-weight: 900;
    box-shadow: 0 6px 20px rgba(238, 38, 119, 0.45);
    cursor: pointer;
  }
  .customer-proof-done-btn:disabled {
    opacity: 0.55;
    cursor: not-allowed;
    box-shadow: none;
  }
  .customer-proof-done-btn:active:not(:disabled) { transform: scale(0.98); }
  .customer-proof-approved-banner {
    margin: 16px 16px 0;
    padding: 16px;
    border-radius: 18px;
    background: #F0FDF4;
    border: 1px solid #86EFAC;
    text-align: center;
    font-size: 15px;
    font-weight: 800;
    color: #166534;
    line-height: 1.45;
  }

  .customer-proof-review-wrap {
    margin: 16px 16px 0;
    padding: 20px 16px 18px;
    border-radius: 22px;
    background: linear-gradient(145deg, #FFFFFF 0%, #FFF7FA 100%);
    border: 2px solid rgba(238, 38, 119, 0.2);
    box-shadow: 0 8px 28px rgba(238, 38, 119, 0.1);
  }
  .customer-proof-review-title {
    margin: 0 0 6px;
    font-size: 20px;
    font-weight: 900;
    color: #2D2D2D;
    text-align: center;
    letter-spacing: -0.02em;
  }
  .customer-proof-review-hint {
    margin: 0 0 16px;
    font-size: 13px;
    line-height: 1.45;
    color: #9D174D;
    font-weight: 600;
    text-align: center;
  }
  .customer-proof-stars {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-bottom: 16px;
  }
  .customer-proof-star-btn {
    padding: 4px;
    border: none;
    background: none;
    cursor: pointer;
    line-height: 0;
    -webkit-tap-highlight-color: transparent;
  }
  .customer-proof-star-btn svg {
    width: 36px;
    height: 36px;
    transition: transform 0.15s ease;
  }
  .customer-proof-star-btn:active svg { transform: scale(0.92); }
  .customer-proof-star-on { color: #F59E0B; fill: #F59E0B; }
  .customer-proof-star-off { color: #E5E7EB; fill: #E5E7EB; }
  .customer-proof-review-text {
    width: 100%;
    min-height: 96px;
    padding: 12px 14px;
    border-radius: 16px;
    border: 1px solid rgba(238, 38, 119, 0.22);
    background: #FFFFFF;
    font-size: 14px;
    line-height: 1.45;
    color: #2D2D2D;
    resize: vertical;
    font-family: inherit;
    box-sizing: border-box;
  }
  .customer-proof-review-text:focus {
    outline: none;
    border-color: ${PINK};
    box-shadow: 0 0 0 3px rgba(238, 38, 119, 0.12);
  }
  .customer-proof-review-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 14px;
  }
  .customer-proof-review-thanks {
    margin: 16px 16px 0;
    padding: 18px 16px;
    border-radius: 18px;
    background: #FFFBEB;
    border: 1px solid #FCD34D;
    text-align: center;
    font-size: 15px;
    font-weight: 800;
    color: #92400E;
    line-height: 1.45;
  }

  .customer-proof-loading {
    display: flex; flex-direction: column; align-items: center;
    justify-content: center; min-height: 60dvh; gap: 16px;
  }
  .customer-proof-loading-text {
    font-size: 14px; font-weight: 600; color: #9D174D;
  }

  .customer-proof-error {
    margin: 24px 16px; padding: 20px; border-radius: 18px;
    background: #FEF2F2; border: 1px solid #FECACA;
  }
  .customer-proof-error-title { font-weight: 800; color: #C2185B; margin: 0 0 8px; }
  .customer-proof-error-text { font-size: 14px; color: #B91C1C; margin: 0; line-height: 1.45; }

  /* Snabbit-style live delivery tracking (customer proof window) */
  .customer-live-track {
    margin: 0 16px 18px;
    padding: 0;
  }
  .customer-live-track-title {
    font-size: 22px;
    font-weight: 900;
    color: #2D2D2D;
    margin: 0 0 12px;
    letter-spacing: -0.02em;
    line-height: 1.2;
  }
  .customer-live-track-live {
    color: ${PINK};
  }
  .customer-live-track-map-shell {
    position: relative;
    border-radius: 22px;
    overflow: hidden;
    background: #FFF0F6;
    box-shadow: 0 10px 36px rgba(238, 38, 119, 0.14);
    border: 1px solid rgba(238, 38, 119, 0.12);
  }
  .customer-live-track-map {
    width: 100%;
    height: 280px;
    display: block;
  }
  .customer-live-track--fullscreen {
    position: fixed;
    inset: 0;
    z-index: 9999;
    margin: 0;
    max-width: none;
    display: flex;
    flex-direction: column;
    background: #FFF7FA;
  }
  .customer-live-track--fullscreen .customer-live-track-map-shell {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    border-radius: 0;
    border: none;
    box-shadow: none;
  }
  .customer-live-track-map--fullscreen {
    height: 100%;
    min-height: 0;
    flex: 1;
  }
  .customer-live-track-title--bar {
    margin: 0;
    font-size: 18px;
    text-align: center;
    flex: 1;
  }
  .customer-live-track-fs-close-btn {
    width: 40px;
    height: 40px;
    border-radius: 999px;
    border: 1px solid rgba(238, 38, 119, 0.2);
    background: white;
    color: ${PINK};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
    -webkit-tap-highlight-color: transparent;
  }
  .customer-live-track-fs-spacer {
    width: 40px;
    flex-shrink: 0;
  }
  .customer-live-track-fullscreen-overlay {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 6;
    padding: 0 10px max(10px, env(safe-area-inset-bottom));
  }
  .customer-live-track-fullscreen-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: max(0.75rem, env(safe-area-inset-top)) 16px 12px;
    border-bottom: 1px solid rgba(235, 179, 169, 0.45);
    background: #FFF7FA;
  }
  .customer-live-track-expand-btn {
    position: absolute;
    right: 12px;
    top: 12px;
    z-index: 5;
    width: 40px;
    height: 40px;
    border-radius: 999px;
    border: 1px solid rgba(238, 38, 119, 0.2);
    background: rgba(255,255,255,0.95);
    color: ${PINK};
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 14px rgba(0,0,0,0.08);
  }
  .customer-live-track-map-fallback {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    font-weight: 700;
    color: rgba(45,45,45,0.55);
    pointer-events: none;
    padding: 16px;
    text-align: center;
  }
  .customer-live-track-map-fallback-link {
    pointer-events: auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 48px;
    padding: 12px 18px;
    border-radius: 14px;
    background: ${PINK};
    color: #fff;
    font-size: 14px;
    font-weight: 800;
    text-decoration: none;
    box-shadow: 0 4px 14px rgba(238, 38, 119, 0.28);
  }
  .customer-live-track-sheet {
    position: relative;
    z-index: 4;
    margin: -36px 0 0;
    padding: 18px 16px 16px;
    border-radius: 20px 20px 18px 18px;
    background: #FFFFFF;
    box-shadow: 0 -4px 28px rgba(0, 0, 0, 0.08), 0 8px 24px rgba(238, 38, 119, 0.08);
    border: 1px solid rgba(238, 38, 119, 0.1);
  }
  .customer-live-track--fullscreen .customer-live-track-sheet {
    margin: 0;
    border-radius: 20px 20px 0 0;
    box-shadow: 0 -8px 32px rgba(0, 0, 0, 0.12);
  }
  .customer-live-track-eta-block {
    padding: 2px 2px 4px;
  }
  .customer-live-track-eta-kicker {
    margin: 0;
    font-size: 14px;
    font-weight: 600;
    color: rgba(45, 45, 45, 0.55);
    line-height: 1.2;
  }
  .customer-live-track-eta-big {
    margin: 4px 0 0;
    font-size: 42px;
    font-weight: 900;
    line-height: 1;
    letter-spacing: -0.03em;
    color: ${PINK};
  }
  .customer-live-track-eta-big--buffer {
    font-size: 16px;
    font-weight: 800;
    line-height: 1.3;
    color: #9D174D;
  }
  .customer-live-track-eta-buffer {
    display: block;
  }
  .customer-live-track-eta-big-unit {
    font-size: 28px;
    font-weight: 800;
    letter-spacing: -0.02em;
  }
  .customer-live-track-eta-status {
    margin: 8px 0 0;
    font-size: 17px;
    font-weight: 800;
    color: #2D2D2D;
    line-height: 1.25;
  }
  .customer-live-track-sheet-divider {
    height: 1px;
    margin: 14px 0;
    background: rgba(45, 45, 45, 0.08);
  }
  .customer-live-track-driver-row {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  .customer-live-track-driver-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: #FFF0F6;
    color: ${PINK};
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .customer-live-track-driver-meta { flex: 1; min-width: 0; }
  .customer-live-track-driver-name {
    margin: 0;
    font-size: 16px;
    font-weight: 800;
    color: #2D2D2D;
    line-height: 1.2;
  }
  .customer-live-track-driver-role {
    margin: 3px 0 0;
    font-size: 13px;
    font-weight: 600;
    color: rgba(45, 45, 45, 0.5);
    line-height: 1.2;
  }
  .customer-live-track-address-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
  }
  .customer-live-track-address-icon {
    flex-shrink: 0;
    margin-top: 2px;
    color: ${PINK};
  }
  .customer-live-track-address-text {
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: rgba(45, 45, 45, 0.72);
    line-height: 1.4;
  }
  .customer-live-track-address-label {
    display: block;
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: rgba(45, 45, 45, 0.45);
    margin-bottom: 2px;
  }
  .customer-live-track-driver-actions {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
  }
  .customer-live-track-icon-btn {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: ${PINK};
    color: #fff;
    text-decoration: none;
    border: none;
    box-shadow: 0 4px 12px rgba(238, 38, 119, 0.28);
  }
  .customer-live-track-icon-btn--chat {
    background: #E8F8EC;
    color: #1F6B34;
    border-color: rgba(31, 107, 52, 0.2);
  }
  .customer-live-track-foot {
    margin: 14px 0 0;
    text-align: center;
    font-size: 13px;
    font-weight: 800;
    color: ${PINK};
    letter-spacing: 0.01em;
  }
  .driver-location-sharing-banner {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    padding: 10px 14px;
    border-radius: 14px;
    background: #ECFDF5;
    border: 1px solid #A7F3D0;
    color: #047857;
    font-size: 12px;
    font-weight: 700;
    line-height: 1.35;
  }
  .driver-location-sharing-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #10B981;
    flex-shrink: 0;
    animation: driver-location-pulse 1.4s ease-in-out infinite;
  }
  @keyframes driver-location-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.55; transform: scale(0.85); }
  }

  .customer-pay-due {
    margin: 14px 16px 0;
    padding: 16px 16px 14px;
    border-radius: 16px;
    background: #FFFBFB;
    border: 1px solid rgba(220, 38, 38, 0.18);
    text-align: center;
  }
  .customer-pay-due--embedded {
    margin: 0;
    padding: 4px 0 0;
    border: none;
    background: transparent;
    box-shadow: none;
    text-align: left;
  }
  .customer-pay-due--embedded .customer-pay-due-kicker {
    text-align: center;
  }
  .customer-pay-due--embedded .customer-pay-due-headline,
  .customer-pay-due--embedded .customer-pay-due-amount,
  .customer-pay-due--embedded .customer-pay-due-note {
    text-align: center;
  }
  .customer-proof-section .customer-pay-due--embedded .customer-pay-scanner-btn,
  .customer-proof-section .customer-pay-due--embedded .customer-pay-app-btn {
    max-width: 100%;
  }
  .customer-pay-due--early-cod {
    background: linear-gradient(180deg, #FFF7FB 0%, #FFFBF5 100%);
    border: 1px solid rgba(238, 38, 119, 0.22);
    box-shadow: 0 8px 24px rgba(238, 38, 119, 0.08);
  }
  .customer-pay-due--open {
    margin: 16px 16px 0;
    padding: 18px 16px 16px;
    border-radius: 20px;
    text-align: center;
  }
  .customer-pay-due--open .customer-pay-due-headline {
    margin-top: 8px;
    font-size: 17px;
    line-height: 1.3;
    color: #2D2D2D;
  }
  .customer-pay-due--open .customer-pay-scanner-btn {
    text-align: center;
  }
  .customer-pay-due--embedded.customer-pay-due--early-cod {
    background: transparent;
    border: none;
    box-shadow: none;
  }
  .customer-pay-due--trust {
    padding: 4px 0 0;
    text-align: center;
  }
  .customer-pay-trust-amount {
    margin: 0;
    font-size: 32px;
    font-weight: 900;
    color: ${PINK};
    line-height: 1;
    letter-spacing: -0.02em;
  }
  .customer-pay-trust-lead {
    margin: 8px 0 14px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.45;
    color: rgba(45, 45, 45, 0.62);
  }
  .customer-pay-due--trust .customer-pay-scanner-btn {
    margin-top: 0;
    padding: 14px 14px 12px;
    border-radius: 18px;
    border: 1.5px solid rgba(238, 38, 119, 0.22);
    background: white;
    box-shadow: 0 8px 24px rgba(238, 38, 119, 0.1);
    text-align: center;
  }
  .customer-pay-due--trust .customer-pay-scanner-label {
    display: inline-flex;
    width: 100%;
    justify-content: center;
    margin-bottom: 12px;
    font-size: 13px;
    font-weight: 800;
    color: ${PINK};
    letter-spacing: -0.01em;
  }
  .customer-pay-due--trust .customer-pay-scanner-hint {
    width: 100%;
    margin-top: 12px;
    font-size: 12px;
    font-weight: 600;
    color: rgba(45, 45, 45, 0.58);
    line-height: 1.4;
  }
  .customer-pay-due--trust .customer-pay-alt-apps {
    margin-top: 14px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .customer-pay-due--trust .customer-pay-alt-btn {
    max-width: none;
    padding: 13px 12px;
    border-radius: 14px;
    border-color: rgba(238, 38, 119, 0.14);
    font-size: 15px;
  }
  .customer-pay-due--trust .customer-pay-vpa {
    margin-top: 14px;
    padding-top: 12px;
    border-top: 1px solid rgba(238, 38, 119, 0.1);
    font-size: 11px;
    line-height: 1.45;
    text-align: center;
  }
  .customer-pay-due--pay-later {
    background: #FFFBFB;
    border-color: rgba(220, 38, 38, 0.18);
  }
  .customer-pay-tab {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 10px;
    padding: 6px 14px;
    border-radius: 999px;
    background: ${PINK};
    color: #fff;
    font-size: 12px;
    font-weight: 800;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }
  .customer-pay-due-headline {
    margin: 4px 0 0;
    font-size: 17px;
    font-weight: 800;
    color: #2D2D2D;
    line-height: 1.25;
  }
  .customer-pay-due--early-cod .customer-pay-due-kicker {
    color: rgba(238, 38, 119, 0.78);
  }
  .customer-pay-due--early-cod .customer-pay-due-amount {
    color: ${PINK};
  }
  .customer-pay-due-note--early {
    color: rgba(45, 45, 45, 0.72);
    font-size: 14px;
    line-height: 1.45;
  }
  .customer-pay-due-kicker {
    margin: 0;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: rgba(185, 28, 28, 0.75);
  }
  .customer-pay-due-amount {
    margin: 6px 0 0;
    font-size: 28px;
    font-weight: 900;
    color: #B91C1C;
    line-height: 1;
  }
  .customer-pay-due-note {
    margin: 8px 0 0;
    font-size: 13px;
    font-weight: 500;
    color: rgba(45, 45, 45, 0.62);
    line-height: 1.4;
  }
  .customer-pay-scanner-btn {
    display: block;
    width: 100%;
    margin-top: 14px;
    padding: 12px 12px 10px;
    border: none;
    border-radius: 14px;
    background: white;
    cursor: pointer;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(15, 118, 110, 0.22);
    -webkit-tap-highlight-color: transparent;
  }
  .customer-pay-scanner-btn:active { transform: scale(0.99); }
  .customer-pay-app-btn {
    display: block;
    width: 100%;
    margin-top: 14px;
    padding: 14px 16px;
    border: none;
    border-radius: 14px;
    font-size: 16px;
    font-weight: 800;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  .customer-pay-app-btn:active { transform: scale(0.99); }
  .customer-pay-app-btn--paytm {
    background: linear-gradient(135deg, #00BAF2 0%, #0080C8 100%);
    color: white;
    box-shadow: 0 4px 14px rgba(0, 128, 200, 0.35);
  }
  .customer-pay-bank-hint {
    margin: 10px 0 0;
    padding: 8px 10px;
    border-radius: 10px;
    background: rgba(245, 158, 11, 0.12);
    font-size: 11px;
    line-height: 1.45;
    color: rgba(120, 53, 15, 0.9);
    text-align: left;
  }
  .customer-pay-bank-hint strong { font-weight: 800; }
  .customer-pay-alt-apps {
    display: flex;
    gap: 10px;
    margin-top: 12px;
    justify-content: center;
  }
  .customer-pay-alt-btn {
    flex: 1;
    max-width: 140px;
    padding: 10px 12px;
    border-radius: 12px;
    border: 1px solid rgba(45, 45, 45, 0.12);
    background: white;
    font-size: 13px;
    font-weight: 800;
    color: #2D2D2D;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  .customer-pay-alt-btn:active { transform: scale(0.98); }
  .customer-pay-scanner-card {
    display: block;
    width: 100%;
    margin-top: 14px;
    padding: 12px 12px 10px;
    border-radius: 14px;
    background: white;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    border: 1px solid rgba(15, 118, 110, 0.22);
  }
  .customer-pay-scanner-label {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    font-size: 12px;
    font-weight: 800;
    color: #0F766E;
    margin-bottom: 10px;
  }
  .customer-pay-scanner-qr { display: flex; justify-content: center; }
  .customer-pay-scanner-hint {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-top: 10px;
    font-size: 11px;
    font-weight: 600;
    color: rgba(45, 45, 45, 0.55);
  }
  .customer-pay-vpa {
    margin: 10px 0 0;
    font-size: 11px;
    color: rgba(45, 45, 45, 0.55);
    word-break: break-all;
  }
  .customer-pay-vpa strong { color: #2D2D2D; font-weight: 800; }
  .customer-pay-static-qr img {
    display: block;
    width: min(200px, 100%);
    margin: 12px auto 0;
    border-radius: 12px;
    border: 1px solid rgba(15, 118, 110, 0.2);
  }
  .customer-pay-scanner-qr img {
    display: block;
    width: min(200px, 100%);
    margin: 0 auto;
    border-radius: 12px;
    border: 2px solid #0F766E;
  }
  .customer-pay-manual {
    margin-top: 14px;
    padding: 12px 14px;
    border-radius: 12px;
    background: rgba(15, 118, 110, 0.06);
    text-align: left;
  }
  .customer-pay-manual-title {
    margin: 0 0 8px;
    font-size: 12px;
    font-weight: 800;
    color: #0F766E;
    text-transform: uppercase;
    letter-spacing: 0.04em;
  }
  .customer-pay-manual-steps {
    margin: 0;
    padding-left: 18px;
    font-size: 13px;
    line-height: 1.55;
    color: rgba(45, 45, 45, 0.82);
  }
  .customer-pay-manual-steps li { margin-bottom: 6px; }
  .customer-pay-manual-steps strong { color: #2D2D2D; font-weight: 800; }
  .customer-pay-copy-inline {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 0;
    border: none;
    background: none;
    font: inherit;
    font-weight: 800;
    color: #0F766E;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  .customer-pay-copied {
    margin: 8px 0 0;
    font-size: 11px;
    font-weight: 700;
    color: #0F766E;
  }
  .customer-pay-trust {
    margin: 10px 0 0;
    font-size: 11px;
    line-height: 1.45;
    color: rgba(45, 45, 45, 0.58);
  }
  .customer-pay-trust strong { color: #2D2D2D; font-weight: 800; }
  .customer-pay-fallback {
    margin: 12px 0 0;
    font-size: 13px;
    color: rgba(45, 45, 45, 0.65);
  }

  /* V2 payment block — matches NCA account (Paytm QR frame + branded alt apps) */
  .customer-pay-due--v2 {
    padding-top: 12px;
    overflow: visible;
  }
  .customer-pay-tab-wrap {
    display: flex;
    justify-content: center;
    padding: 0 16px;
    margin-bottom: 10px;
  }
  .customer-pay-due--v2 .customer-pay-tab {
    margin: 0;
    padding: 7px 16px;
    font-size: 11px;
    letter-spacing: 0.06em;
  }
  .customer-pay-due--v2 .customer-pay-due-kicker {
    color: rgba(238, 38, 119, 0.78);
  }
  .customer-pay-due-amount--v2 {
    margin: 8px 0 0;
    font-size: 30px;
    font-weight: 900;
    color: ${PINK};
    line-height: 1;
  }
  .customer-pay-due-note--short {
    margin: 6px 0 0;
    font-size: 14px;
    color: rgba(45, 45, 45, 0.62);
    line-height: 1.45;
  }
  .customer-pay-scanner-btn-v2 {
    display: block;
    width: 100%;
    margin-top: 14px;
    padding: 14px 14px 12px;
    border: 1px solid rgba(0, 128, 200, 0.25);
    border-radius: 16px;
    background: white;
    cursor: pointer;
    box-shadow: 0 2px 12px rgba(0, 128, 200, 0.12);
    text-align: center;
    -webkit-tap-highlight-color: transparent;
  }
  .customer-pay-scanner-btn-v2:active { transform: scale(0.99); }
  .customer-pay-scanner-label-navy {
    display: block;
    font-size: 14px;
    font-weight: 800;
    color: #002970;
    letter-spacing: -0.01em;
  }
  .customer-pay-scanner-qr-wrap {
    display: flex;
    justify-content: center;
    margin-top: 12px;
  }
  .customer-paytm-qr-frame {
    display: inline-block;
    margin: 0 auto;
    padding: 10px;
    border-radius: 22px;
    background: linear-gradient(to bottom, #00BAF2 0%, #00BAF2 50%, #002970 50%, #002970 100%);
  }
  .customer-paytm-qr-inner {
    border-radius: 14px;
    background: #fff;
    padding: 12px;
  }
  .customer-pay-qr-img {
    display: block;
    margin: 0 auto;
  }
  .customer-pay-alt-apps--branded {
    margin-top: 12px;
    gap: 10px;
  }
  .customer-pay-gpay-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 10px;
    border-radius: 12px;
    border: 1px solid #DADCE0;
    background: #fff;
    box-shadow: 0 1px 3px rgba(60, 64, 67, 0.15);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  .customer-pay-gpay-btn:active { transform: scale(0.98); }
  .customer-pay-gpay-word {
    font-size: 16px;
    font-weight: 800;
    letter-spacing: -0.02em;
  }
  .customer-pay-gpay-g { color: #4285F4; }
  .customer-pay-gpay-o1 { color: #EA4335; }
  .customer-pay-gpay-o2 { color: #FBBC04; }
  .customer-pay-gpay-g2 { color: #4285F4; }
  .customer-pay-gpay-l { color: #34A853; }
  .customer-pay-gpay-e { color: #EA4335; }
  .customer-pay-gpay-pay { color: #3C4043; margin-left: 4px; }
  .customer-pay-phonepe-btn {
    flex: 1;
    padding: 12px 10px;
    border: none;
    border-radius: 12px;
    background: linear-gradient(135deg, #7B3FE4 0%, #5F259F 100%);
    color: #fff;
    font-size: 14px;
    font-weight: 800;
    box-shadow: 0 4px 14px rgba(95, 37, 159, 0.35);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  .customer-pay-phonepe-btn:active { transform: scale(0.98); }

  .driver-live-map-section {
    margin-bottom: 14px;
    border-radius: 20px;
    overflow: hidden;
    background: #FFF7FA;
    border: 1px solid rgba(238, 38, 119, 0.15);
    box-shadow: 0 8px 28px rgba(238, 38, 119, 0.1);
  }
  .driver-live-map-head {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px 10px;
    color: ${PINK};
  }
  .driver-live-map-head-text { flex: 1; min-width: 0; }
  .driver-live-map-title {
    margin: 0;
    font-size: 15px;
    font-weight: 900;
    color: #2D2D2D;
    line-height: 1.2;
  }
  .driver-live-map-eta-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 8px;
  }
  .driver-live-map-eta-block { flex-shrink: 0; }
  .driver-live-map-eta-kicker {
    margin: 0;
    font-size: 10px;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #9D174D;
  }
  .driver-live-map-eta-big {
    margin: 2px 0 0;
    font-size: 32px;
    font-weight: 900;
    line-height: 1;
    color: ${PINK};
    letter-spacing: -0.03em;
  }
  .driver-live-map-eta-big--buffer {
    font-size: 14px;
    font-weight: 800;
    line-height: 1.3;
    color: #9D174D;
  }
  .driver-live-map-eta-buffer {
    display: block;
  }
  .driver-live-map-eta-unit {
    font-size: 14px;
    font-weight: 800;
    color: #9D174D;
    margin-left: 2px;
  }
  .driver-live-map-sub {
    margin: 0;
    font-size: 11px;
    font-weight: 600;
    color: #9D174D;
    line-height: 1.35;
  }
  .driver-live-map-shell {
    position: relative;
    background: #FFF0F6;
  }
  .driver-live-map-canvas {
    width: 100%;
    height: 300px;
    display: block;
  }
  .driver-live-map-expand-btn {
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 5;
    width: 42px;
    height: 42px;
    border-radius: 999px;
    border: 1px solid rgba(238, 38, 119, 0.22);
    background: rgba(255, 255, 255, 0.96);
    color: ${PINK};
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  .driver-live-map--fullscreen {
    position: fixed;
    inset: 0;
    z-index: 9999;
    margin: 0;
    max-width: none;
    border-radius: 0;
    border: none;
    display: flex;
    flex-direction: column;
    background: #FFF7FA;
  }
  .driver-live-map-fs-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: max(10px, env(safe-area-inset-top)) 12px 10px;
    border-bottom: 1px solid rgba(238, 38, 119, 0.12);
    background: #FFF7FA;
  }
  .driver-live-map-fs-close {
    width: 40px;
    height: 40px;
    border-radius: 999px;
    border: 1px solid rgba(238, 38, 119, 0.2);
    background: white;
    color: ${PINK};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    flex-shrink: 0;
  }
  .driver-live-map-fs-title {
    flex: 1;
    margin: 0;
    text-align: center;
    font-size: 17px;
    font-weight: 900;
    color: #2D2D2D;
  }
  .driver-live-map-fs-spacer {
    width: 40px;
    flex-shrink: 0;
  }
  .driver-live-map--fullscreen .driver-live-map-shell {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
  .driver-live-map-canvas--fullscreen {
    flex: 1;
    min-height: 0;
    height: 100% !important;
  }
  .driver-live-map-fs-overlay {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 4;
    padding: 12px 14px max(14px, env(safe-area-inset-bottom));
    background: linear-gradient(180deg, rgba(255, 247, 250, 0) 0%, rgba(255, 247, 250, 0.92) 28%, #FFF7FA 100%);
  }
  .driver-live-map-eta-panel {
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid rgba(238, 38, 119, 0.14);
    padding: 12px 14px;
    box-shadow: 0 8px 24px rgba(238, 38, 119, 0.12);
  }
  .driver-live-map-eta-addr {
    display: flex;
    align-items: flex-start;
    gap: 6px;
    margin: 10px 0 0;
    font-size: 12px;
    font-weight: 600;
    color: #6B4E57;
    line-height: 1.4;
  }
  .driver-live-map-addr {
    margin: 0;
    padding: 10px 14px 12px;
    font-size: 12px;
    font-weight: 600;
    color: #6B4E57;
    line-height: 1.4;
    border-top: 1px solid rgba(238, 38, 119, 0.1);
  }

  /* \u2500\u2500 Review popup bottom-sheet \u2500\u2500 */
  .cp-review-backdrop {
    position: fixed;
    inset: 0;
    z-index: 200;
    background: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(3px);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    animation: cp-backdrop-in 0.22s ease;
  }
  @keyframes cp-backdrop-in {
    from { opacity: 0; }
    to   { opacity: 1; }
  }
  .cp-review-sheet {
    width: 100%;
    max-width: 480px;
    padding: 28px 20px calc(24px + env(safe-area-inset-bottom));
    border-radius: 28px 28px 0 0;
    background: #FFFFFF;
    box-shadow: 0 -16px 48px rgba(238, 38, 119, 0.18);
    border-top: 1px solid rgba(238, 38, 119, 0.14);
    animation: cp-sheet-up 0.28s cubic-bezier(0.32, 0.72, 0, 1);
    text-align: center;
  }
  @keyframes cp-sheet-up {
    from { transform: translateY(100%); }
    to   { transform: translateY(0); }
  }
  .cp-review-sheet-handle {
    width: 40px;
    height: 4px;
    border-radius: 999px;
    background: rgba(45, 45, 45, 0.14);
    margin: 0 auto 22px;
  }
  .cp-review-sheet-emoji {
    font-size: 36px;
    line-height: 1;
    margin-bottom: 10px;
  }
  .cp-review-sheet-title {
    margin: 0 0 6px;
    font-size: 22px;
    font-weight: 900;
    letter-spacing: -0.03em;
    color: #2D2D2D;
  }
  .cp-review-sheet-sub {
    margin: 0 0 20px;
    font-size: 13px;
    line-height: 1.5;
    color: rgba(45, 45, 45, 0.58);
    font-weight: 600;
  }
  .cp-review-sheet-stars {
    display: flex;
    justify-content: center;
    gap: 10px;
    margin-bottom: 18px;
  }
  .cp-review-sheet-star-btn {
    padding: 6px;
    border: none;
    background: none;
    cursor: pointer;
    line-height: 0;
    -webkit-tap-highlight-color: transparent;
    transition: transform 0.12s ease;
  }
  .cp-review-sheet-star-btn:active { transform: scale(0.88); }
  .cp-review-sheet-star-btn svg {
    width: 44px;
    height: 44px;
  }
  .cp-review-sheet-textarea {
    width: 100%;
    min-height: 88px;
    padding: 14px 16px;
    border-radius: 18px;
    border: 1px solid rgba(238, 38, 119, 0.18);
    background: #FAFAFA;
    font-size: 14px;
    line-height: 1.45;
    color: #2D2D2D;
    resize: vertical;
    font-family: inherit;
    box-sizing: border-box;
    margin-bottom: 16px;
    text-align: left;
  }
  .cp-review-sheet-textarea:focus {
    outline: none;
    border-color: ${PINK};
    background: white;
    box-shadow: 0 0 0 3px rgba(238, 38, 119, 0.1);
  }
  .cp-review-sheet-submit {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    width: 100%;
    padding: 17px 20px;
    border-radius: 999px;
    border: none;
    background: linear-gradient(135deg, ${PINK} 0%, #DB2777 100%);
    color: white;
    font-size: 17px;
    font-weight: 900;
    letter-spacing: -0.01em;
    box-shadow: 0 8px 24px rgba(238, 38, 119, 0.38);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    margin-bottom: 10px;
  }
  .cp-review-sheet-submit:disabled { opacity: 0.55; box-shadow: none; cursor: not-allowed; }
  .cp-review-sheet-submit:active:not(:disabled) { transform: scale(0.98); }
  .cp-review-sheet-skip {
    width: 100%;
    padding: 10px;
    border: none;
    background: none;
    font-size: 14px;
    font-weight: 700;
    color: rgba(45, 45, 45, 0.45);
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
  .cp-review-sheet-thanks-emoji {
    font-size: 42px;
    margin-bottom: 10px;
    display: block;
  }
  .cp-review-sheet-thanks-title {
    margin: 0 0 6px;
    font-size: 20px;
    font-weight: 900;
    color: #2D2D2D;
  }
  .cp-review-sheet-thanks-sub {
    margin: 0 0 22px;
    font-size: 13px;
    font-weight: 600;
    color: rgba(45, 45, 45, 0.55);
    line-height: 1.5;
  }
  .cp-review-sheet-close {
    width: 100%;
    padding: 14px;
    border: none;
    border-radius: 999px;
    background: #F5F2EA;
    font-size: 15px;
    font-weight: 800;
    color: #2D2D2D;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
  }
`;
